import Button from '@mui/joy/Button';
// import Checkbox from '@mui/joy/Checkbox';
import Divider from '@mui/joy/Divider';
import FormControl from '@mui/joy/FormControl';
import FormLabel from '@mui/joy/FormLabel';
import JoyLink from '@mui/joy/Link';
import Input from '@mui/joy/Input';
import Stack from '@mui/joy/Stack';
import Box from '@mui/joy/Box';
import Typography from '@mui/joy/Typography';
import { gql, useMutation } from '@apollo/client';
import { useFeedback } from '../feedback/Service';
import { AUTH_TOKEN_NAME } from '../../constants';
import { parseGraphQLError } from '../../utils';
import { useState } from 'react';
import GoogleLoginButton from './GoogleLoginButton';
import { Link, /* useNavigate */ } from 'react-router';
import useUser from './useUser';

const LOGIN = gql`
  mutation Login($user: Login!) {
    login(user: $user)
  }
`;

const GOOGLE_LOGIN = gql`
  mutation GoogleLogin($credentials: GoogleCredentials!) {
    googleLogin(credentials: $credentials)
  }
`;

const RESTORE_PASSWORD = gql`
  mutation RestorePassword($email: String!) {
    restorePassword(email: $email)
  }
`;

const SignInForm = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [login, { loading: formLoading }] = useMutation(LOGIN);
  const [googleLogin, { loading: googleLoading }] = useMutation(GOOGLE_LOGIN);
  const [restorePassword] = useMutation(RESTORE_PASSWORD);
  const { refetch: getUser, loading: userLoading } = useUser({ notifyOnNetworkStatusChange: true });
  const feedback = useFeedback();

  const handleSubmit = async event => {
    event.preventDefault();
    const user = { email, password };
    try {
      const { data: { login: token } } = await login(({ variables: { user } }));
      localStorage.setItem(AUTH_TOKEN_NAME, token);
      // await client.clearStore();
      getUser({ fetchPolicy: 'network-only' });
    } catch (error) {
      console.warn("Login error", error);
      feedback.snackbar({ text: parseGraphQLError(error), type: "error" });
    }
  }

  const handleGoogleLogin = async (credentials) => {
    console.log("handleGoogleLogin", credentials);
    try {
      const { data: { googleLogin: token } } = await googleLogin(({ variables: { credentials } }));
      localStorage.setItem(AUTH_TOKEN_NAME, token);
      console.log("Google login token", token);
      // await client.clearStore();
      getUser({ fetchPolicy: 'network-only' });
    } catch (error) {
      console.warn("Google login error", error);
      feedback.snackbar({ text: parseGraphQLError(error), type: "error" });
    }
  }

  const handleForgotPassword = async e => {
    e.preventDefault();
    const restorationEmail = await feedback.form({ title: "Restore Password", input: { title: "Email Address", initialValue: email, name: "email", type: "email" } });
    if (!restorationEmail)
      return;
    try {
      /* const { data: {restorePassword: token } } =  */await restorePassword(({ variables: { email: restorationEmail } }));
      feedback.snackbar({ text: "Instructions sent to your email", type: "info" });
      // history.push("/reset-password#" + token);
    } catch (error) {
      console.error("Restore password error", error);
      feedback.snackbar({ text: parseGraphQLError(error), type: "error" });
    }
  }

  return (
    <Box
      component="main"
      sx={{
        my: 'auto',
        py: 2,
        pb: 5,
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
        width: 400,
        maxWidth: '100%',
        mx: 'auto',
        borderRadius: 'sm',
        '& form': {
          display: 'flex',
          flexDirection: 'column',
          gap: 2,
        },
        [`& .MuiFormLabel-asterisk`]: {
          visibility: 'hidden',
        },
      }}
    >
      <Stack sx={{ gap: 4, mb: 2 }}>
        <Stack sx={{ gap: 1 }}>
          <Typography component="h1" level="h3">
            Sign in
          </Typography>
          <Typography level="body-sm">
            New to Cavalry?{' '}
            <JoyLink level="title-sm" component={Link} to="../sign-up">
              Sign up!
            </JoyLink>
          </Typography>
        </Stack>
        <GoogleLoginButton onSuccess={handleGoogleLogin} />
      </Stack>
      <Divider
        sx={(theme) => ({
          [theme.getColorSchemeSelector('light')]: {
            color: { xs: '#FFF', md: 'text.tertiary' },
          },
        })}
      >
        or
      </Divider>
      <Stack sx={{ gap: 4, mt: 2 }}>
        <form
          onSubmit={handleSubmit}
        >
          <FormControl required>
            <FormLabel>Email</FormLabel>
            <Input type="email" name="email" value={email} onChange={e => setEmail(e.target.value)} />
          </FormControl>
          <FormControl required>
            <FormLabel>Password</FormLabel>
            <Input type="password" name="password" value={password} onChange={e => setPassword(e.target.value)} />
          </FormControl>
          <Stack sx={{ gap: 4, mt: 2 }}>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
              }}
            >
              {/* <Checkbox size="sm" label="Remember me" name="persistent" /> */}
              <JoyLink level="title-sm" href="#" onClick={handleForgotPassword}>
                Forgot your password?
              </JoyLink>
            </Box>
            <Button type="submit" fullWidth loading={formLoading || googleLoading || userLoading}>
              Sign in
            </Button>
          </Stack>
        </form>
      </Stack>
    </Box>
  );
}

export default SignInForm;